module.exports = __webpack_public_path__ + "assets/images/lapin-panicking-736affd219fed1014f77c8aa686b78ea.png";